import React, { Component, Fragment } from 'react';
import ClassNames from 'classnames';
import Moment from 'moment';
import { withRouter } from 'react-router';

import { DateRangePicker, SingleDatePicker } from 'react-dates';
import { connect } from 'react-redux';
import Input from 'Components/Input';
import ActionLoader from 'Components/ActionLoader/index';
import {
   SERVICE_TYPES,
   SERVICE_MODES,
   INSURANCE_BY,
   RFQ_NAME_AUTOPOPULATE,
   CONTRACTING_TYPE,
   CONTRACTING_CATEGORY_TYPE,
   SERVICE_FTL,
   ACC,
   SERVICE_TYPE_CATEGORIES,
   HIKAL,
   CENTURY_PLY,
   CARGIL,
   ROQUETTE,
   CARGIL_FTL_CONTRACT_TYPE_LIST,
   BACARDI,
   DEEPAK_PHENOLICS,
   DEEPAK_PHENOLICS_SAP,
   CONTAINER_SERVICE_MODE_CATEGORIES,
   MITSUI
} from 'Constants/commonConstants';
import Select from "react-select";

import { SAVE_EXTEND_DATE_DETAILS, GET_PRICING_BASIS, GET_PRODUCT_CATEGORIES, GET_PACKING_TYPES ,UPLOAD_DOCUMENT} from 'Constants/actionConstants';

import { ReactComponent as FTLIcon } from 'Icons/ftl-road.svg'
import { ReactComponent as LCLIcon } from 'Icons/lcl-express.svg'
import { ReactComponent as CourierIcon } from 'Icons/courier.svg'
import { ReactComponent as ContainerIcon } from 'Icons/container.svg'
import { ReactComponent as BulkIcon } from 'Icons/bulk.svg'

import { ReactComponent as RoadIcon } from 'Icons/road.svg'
import { ReactComponent as BusIcon } from 'Icons/bus.svg'
import { ReactComponent as RailIcon } from 'Icons/rail.svg'
import { ReactComponent as AirIcon } from 'Icons/air.svg'

import { ReactComponent as ConsignerIcon } from 'Icons/consigner.svg'
import { ReactComponent as ConsigneeIcon } from 'Icons/consignee.svg'
import { ReactComponent as AgreedMutuallyIcon } from 'Icons/agreed-mutually.svg'
import { ReactComponent as NotAvailableIcon } from 'Icons/truck.svg'
import Checkbox from 'Components/Checkbox/index';
import ClickOutside from 'Components/ClickOutside/index';

import { getUser } from 'Utils/storage';
import ReactTooltip from 'react-tooltip';
import { isAdaniWilmar, isFosroc } from 'Utils/';

import { toPascalCase } from '../../utils/validate';
import Dropdown from 'Components/Dropdown';
import UploadFilePopup from 'Components/SeekerBidsTable/uploadFilePopup';
import { ProjectDetails } from 'Pages/SupplierRFQCreateOrUpdateRequest/CardT1';
import { isDesmet, isGreenPly } from 'Utils/index';


const serviceTypeToModeMapping = {
   1: [5],
   2: [1, 2, 3, 4],
   3: [4, 5],
   4: [5],
   5: [1, 2, 3, 4],
   6: [1, 2, 3, 4]
};
const rfqTypeToServiceTypeMapping = {
   1: [1, 2, 3, 4, 5],
   2: [4],
   3: [],
   4: [3],
   5: [4, 5],
   6: [4]
}
class RFQDetails extends Component {
   constructor(props) {
      super(props);
      this.rfqDetails = props.rfqDetails;
      this.rfq = props.rfq;
      this.biddingDetails = props.rfq.biddingDetails;

      this.state = {
         nameVal: '',
         generateRFQName: this.props.generateRFQName,
         hasRFQNameChanged: false,
         rfqDetails: this.rfqDetails,
			selectedSubPlants: this.props.selectedSubPlant && this.props.selectedSubPlant.length > 0 && this.props.selectedSubPlant || this.rfq.subplant_name || [],
			selectedSub: [],
         allSubPlants: this.props.allSubPlants,
         rfqId: window.location,
         selectedContractingType: this.props.selectedContracting && this.props.selectedContracting.length > 0 && this.props.selectedContracting || this.rfq.contracting_type || [],
         allContractingType: JSON.parse(JSON.stringify(CONTRACTING_TYPE)),
         allContractCategoryType : JSON.parse(JSON.stringify(CONTRACTING_CATEGORY_TYPE)),
         selectedContractCategoryType:this.props.selectedContractCategory && this.props.selectedContractCategory.length>0 && this.props.selectedContractCategory || this.rfq.contegory_type || [],
         extend_contract_tenure_docs: [],
         extend_contract_tenure_remarks:"",
         mandatory_error_message:false,
      }
      this.viewMode = props.viewMode;
      
   }
   componentWillUnmount() {
      localStorage.setItem('state', 'isDisable');
   }

   componentDidMount() {
      const user= getUser();
      // if (this.props.rfqType === 3) {
      //    const { dispatch, rfqType } = this.props;
      //    dispatch({
      //       type: GET_PRICING_BASIS,
      //       data: {
      //          rfqType: rfqType
      //       },
      //    })
      // } else if(this.props.rfqType === 4) {
      //    const { dispatch, rfqType } = this.props;
      //    dispatch({
      //       type: GET_PRICING_BASIS,
      //       data: {
      //          rfqType: rfqType,
      //          serviceType: 3
      //       },
      //    })
      // }else if(this.props.rfqType === 5) {
      //    const { dispatch, rfqType } = this.props;
      //    dispatch({
      //       type: GET_PRICING_BASIS,
      //       data: {
      //          rfqType: rfqType,
      //          serviceType: 5
      //       },
      //    })
      // }

         const { dispatch, rfqType, selectedNavBranch } = this.props;
         const params = {
            rfqType: rfqType,
            companyId: user.id,
            branchId: (selectedNavBranch || {}).branch_id || user.branchId
         }
         dispatch({
            type: GET_PRICING_BASIS,
            data: params
         })
         dispatch({
            type: GET_PRODUCT_CATEGORIES,
            data: params
         })
         dispatch({
            type: GET_PACKING_TYPES,
            data: params
         })
      
      
      // if(this.props.rfqType === 5){
      //    const { dispatch, rfqType } = this.props;
      //    dispatch({
      //       type: GET_PACKING_TYPES,
      //       data: {
      //          rfqType: rfqType,
      //          serviceType: 5 
      //       },
      //    })
      // }
      
      if(this.rfqDetails.courierTatWeight===0){
      this.rfqDetails.setCourierPriceWeight(100);
      }
      if(this.rfqDetails.courierTatWeight===0){
         this.rfqDetails.setCourierTatWeight(0)
      }
   }

   componentWillReceiveProps(nextProps) {
      if (RFQ_NAME_AUTOPOPULATE) {
         if (nextProps.generateRFQName && this.props.generateRFQName !== nextProps.generateRFQName) {
            this.setState({
               generateRFQName: nextProps.generateRFQName,
               hasRFQNameChanged: true,
            });
         }
         // else {
         //     this.setState({
         //         hasRFQNameChanged: false,
         //     });
         // }
      } 

      if (this.props.allSubPlants !== nextProps.allSubPlants) {
         let existPlants = [];
         if(nextProps.allSubPlants.length > 0 && this.state.selectedSubPlants) {
            (nextProps.allSubPlants || []).map(el => {
               const plantDetail = (this.state.selectedSubPlants || []).find(sPlant => sPlant.plant === el.plant);
               if(plantDetail) {
                  existPlants.push(plantDetail);
               }
            });
         }
         this.setState({
            allSubPlants: nextProps.allSubPlants,
            selectedSubPlants: existPlants
         }, () => {
            if(!this.state.selectedSubPlants.length && this.state.allSubPlants.length > 0) {
               this.handleSubPlantSelection();
            }
         });
      }
   }
   showDocumentType = () => {
      this.setState({
         isDocumentTypeShown: true
      })
   }
   hideDocumentType = () => {
      this.setState({
         isDocumentTypeShown: false
      })
   }
   checkIsOutSide = (date, serviceType) => {
      if (serviceType === 4)
         return !Moment(date).isBetween(Moment(new Date()), Moment(new Date()).add(7, 'days'));
      else
         return Moment(date) < Moment(new Date());
   }
   setServiceCategoryType = (type) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setServiceCategoryType(type.value, type.name);
      this.setState({
         rfqDetails: this.rfqDetails
      });
   }
   toggleServiceType = (e, serviceTypeName) => {
      if (this.viewMode) {
         return;
      }
      const serviceTypeValue = parseInt(e.currentTarget.getAttribute('name'));
      this.rfqDetails.setServiceType(serviceTypeValue, serviceTypeName);
      this.rfqDetails.setServiceModes([]);
      let startDate = !this.rfqDetails.contractTenureTo ? Moment(this.rfqDetails.contractTenureFrom || null) : Moment(this.rfqDetails.contractTenureFrom);
      let endDate = null;
      this.rfqDetails.setContractTenureFrom(startDate);
      this.rfqDetails.setContractTenureTo(endDate);
      this.setState({
         rfqDetails: this.rfqDetails
      });
      if (serviceTypeValue === 4) {
         endDate = Moment(startDate).add(6, 'days');
         this.rfqDetails.setContractTenureFrom(startDate.valueOf());
         this.rfqDetails.setContractTenureTo(endDate.valueOf());
         this.setState({
            rfqDetails: this.rfqDetails
         })
      }
		if(![3, 4, 5].includes(serviceTypeValue)){
			const { dispatch } = this.props;
			dispatch({
				type: GET_PRICING_BASIS,
			})
		} else {
			const { dispatch, rfqType } = this.props;
			dispatch({
				type: GET_PRICING_BASIS,
				data: {
					rfqType: rfqType,
					serviceType: serviceTypeValue === 4 ? 5 : serviceTypeValue
				},
			})
         this.showDocumentType();
      } if (serviceTypeValue === 1 || serviceTypeValue === 4) {
         this.rfqDetails.setServiceModes([5]);
      }
      this.props.onChange();
   }
   toggleServiceMode = (e) => {
      if (this.viewMode) {
         return;
      }
      const serviceModeValue = parseInt(e.currentTarget.getAttribute('name'));
      const serviceModesSelected = [...this.rfqDetails.serviceModes];
      const index = serviceModesSelected.indexOf(serviceModeValue);
      if (index < 0) {
         serviceModesSelected.push(serviceModeValue);
      } else {
         serviceModesSelected.splice(index, 1);
      }
      this.rfqDetails.setServiceModes(serviceModesSelected);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }
   selectInsuranceBy = (e) => {
      if (this.viewMode) {
         return;
      }
      const insuranceByValue = parseInt(e.currentTarget.getAttribute('name'));
      this.rfqDetails.setInsuranceBy(insuranceByValue);
      this.setState({
         rfqDetails: this.rfqDetails
      });
      this.props.onChange();
   }
   changeRFQName = (e) => {
      if (this.viewMode) {
         return;
      }
      let val = e.target.value;
      // if (this.state.hasRFQNameChanged) {
      //     val = val + this.props.generateRFQName;
      // }
      this.rfqDetails.setName(val);
      this.setState({
         nameVal: val,
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   changeOtherRemarks = (e) => {
      if (this.viewMode) {
         return;
      }
      let val = e.target.value;
      this.rfqDetails.setOtherRemarks(val);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

	onChange =(e) => {
		if (this.viewMode) {
			return;
		}
		if (e.target.value <= 100 && e.target.value >= 0){
		this.rfqDetails.setCourierPriceWeight(100 - (e.target.value));
		this.rfqDetails.setCourierTatWeight(e.target.value)
		this.setState({
			rfqDetails: this.rfqDetails
		})
		this.props.onChange();
		}else{
			alert("Enter Tat Weight In The Range 0-100")
		}
	}
   shouldRenderServiceMode = (serviceMode) => {
      const serviceType = this.rfqDetails.serviceType;
      const { rfqType } = this.props;
      return (rfqType === 1 ? serviceTypeToModeMapping[serviceType] : rfqType === 5  ? ((HIKAL.includes(getUser().companyId) && this.rfqDetails.serviceCategoryType === 2) ? [11] : [6, 8]) :  rfqType === 6 ? [6, 9, 10, 8] : [6, 7, 8]).indexOf(serviceMode) > -1;
   }
   shouldRenderServiceType = (serviceType) => {
      const { rfqType } = this.props;
      return (rfqTypeToServiceTypeMapping[rfqType].indexOf(serviceType) > -1)
   }
   selectDocumentType = (type) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setDocumentType(type);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }
   setIncoTerms = (type, name) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setIncoTerms(type, name);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   setDisposalContractType = (type) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setDisposalContractType(type);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   setTripsType = (tripsType) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setTripsType(tripsType);
      if (isGreenPly() && tripsType === 2){
         this.rfqDetails.setAcceptPartialSolution(false);
      }
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }
   setMultiLevelMovementType = (multiLevelMovementType) => {
      if (this.viewMode) {
         return;
      }
      if (this.props.rfqType === 2 || this.props.rfqType === 5 || this.props.rfqType === 6) {
         this.rfqDetails.setMultiLevelMovementType(multiLevelMovementType);
         this.setState({
            rfqDetails: this.rfqDetails
         })
      }
      this.props.onChange();
   }

   setShippingType = (shippingType) => {
      if (this.viewMode) {
         return;
      }
      if (this.props.rfqType === 5) {
         this.rfqDetails.setShippingType(shippingType);
         this.setState({
            rfqDetails: this.rfqDetails
         })
      }
      this.props.onChange();
   }

   setSecondaryContractType = (secondaryContractType) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setSecondaryContractType(secondaryContractType);
      if(isAdaniWilmar() && this.rfq.type === 3 && (this.props || []).pricingBasis.length > 0) {
         this.rfq.biddingDetails.setPricingBasis((this.props.pricingBasis || []).find(pricing => pricing.value == (secondaryContractType === 2 ? 6 : 17)));
      } 
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   setftlContractType = (option) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setftlContractType(option.value);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   setVendorBiddingStatus = (option) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setVendorBiddingStatus(option);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   setOtherCosts = (otherCosts) => {
      if (this.viewMode) {
         return
      }
      this.rfqDetails.setOtherCosts(!this.rfqDetails.otherCosts)
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   // saveExtendDate = () => {
   //    // const rfq_id = this.state.rfqId.pathname;
   //    const { dispatch, history, match } = this.props;
   //    if (match.params.id) {
   //       if (this.props.rfqDetails.contractTenureTo && this.props.rfqDetails.contractTenureFrom) {
   //          dispatch({
   //             type: SAVE_EXTEND_DATE_DETAILS,
   //             data: {
   //                contract_tenure_to: new Date(this.props.rfqDetails.contractTenureTo).setHours(23, 59, 59),
   //                contract_tenure_from: new Date(this.props.rfqDetails.contractTenureFrom).setHours(0, 0, 0, 0),
   //                rfq_id: match.params.id,
   //                rfqType: match.params.type && Number(match.params.type)
   //             },
   //          })
   //       }
   //    }
   // }
   saveExtendDate = () => {
      const { dispatch, history, match } = this.props;
    
      if (match.params.id) {
        let payload;
    
        if (this.props.rfqDetails.contractTenureTo && this.props.rfqDetails.contractTenureFrom) {
          payload = {
            contract_tenure_to: new Date(this.props.rfqDetails.contractTenureTo).setHours(23, 59, 59),
            contract_tenure_from: new Date(this.props.rfqDetails.contractTenureFrom).setHours(0, 0, 0, 0),
            rfq_id: match.params.id,
            rfqType: match.params.type && Number(match.params.type),
          };    
          if (isAdaniWilmar()) {
            if (!this.state.extend_contract_tenure_remarks) {
               this.setState({
                 mandatory_error_message: true,
               });
               return;
             }
            payload.extend_contract_tenure_docs = this.state.extend_contract_tenure_docs;
            payload.extend_contract_tenure_remarks = this.state.extend_contract_tenure_remarks;
          }    
          dispatch({
            type: SAVE_EXTEND_DATE_DETAILS,
            data: payload,
          });
        }
        this.setState({
         showUploadPopup:false
      })
      }
    }
    
   calculateMovmentType = () => {
      const { rfqDetails } = this.state;
      const { contractTenureList } = this.props;
      if (rfqDetails.contractTenureFrom && rfqDetails.contractTenureTo) {
         const momentFrom = Moment(rfqDetails.contractTenureFrom);
         const momentTo = Moment(rfqDetails.contractTenureTo);
         const duration = Moment.duration(momentTo.diff(momentFrom));
         // let days = duration.days() + 1;
         const days = Math.floor(duration.asDays());

         if (duration.months() > 0 || days >= 0) {
            let type = 1;
            let typeName = "";
            if(contractTenureList && contractTenureList.length > 0 && rfqDetails.serviceType !== 4) {
               let isDone = false;
               (contractTenureList || []).map(el => {
                  if(el.uom === 'weeks') {
                     el.fromRange = el.fromRange * 7;
                     el.toRange = el.toRange && (el.toRange * 7) || el.toRange;
                  } else if(el.uom === 'months') {
                     el.fromRange = el.fromRange * 30;
                     el.toRange = el.toRange && (el.toRange * 30) || el.toRange;
                  }
                  if(days >= el.fromRange && (el.toRange ? days <= el.toRange : true) && !isDone) {
                     isDone = true;
                     typeName = el.contract_type;
                     type = el.contract_type_id;
                  }
               })
            } else if(rfqDetails.serviceType === 4) {
               if(days >= 1 && days <= 7) {
                  type = 2;
                  typeName = "Short";
               } else if(days > 7) {
                  type = 4;
                  typeName = "Long";
               }
            } else {
               switch (true) {
                  case (duration.months() === 0 && days === 1 && rfqDetails.serviceType !== 4):
                     typeName = "Spot";
                     break;

                  case (duration.months() === 0 && (days >= 2 && days <= 7) && rfqDetails.serviceType !== 4):
                     typeName = "Short";
                     break;

                  case (duration.months() === 0 && (days >= 8 && days <= 31) && rfqDetails.serviceType !== 4):
                     typeName = "Monthly";
                     break;

                  case (duration.months() > 0 || days > 31 && rfqDetails.serviceType !== 4):
                     typeName = "Long";
                     break;

                  case (duration.months() === 0 && (days >= 1 && days <= 7) && rfqDetails.serviceType === 4):
                     type = 5;
                     typeName = "Short";
                     break;

                  case (duration.months() === 0 && (days > 7) && rfqDetails.serviceType === 4):
                     type = 6;
                     typeName = "Long";
                     break;

                  default:
                     type = -1;
                     break;
               }
            }
            rfqDetails.setMovementType(type, typeName);
            if(ROQUETTE.includes(getUser().companyId)) {
               this.props.searchGroupsAndTransporters( '', '',this.props.rfqType === 2, false, type);
            }
         }

      } else {
         rfqDetails.setMovementType(-1, "");
      }
      return rfqDetails.movementTypeName;
   }

   handleSubPlantSelection = (subPlant) => {
      let { selectedSubPlants, selectedSub, allSubPlants } = this.state;
      let existPlants = [];

      // if (Object.keys(subplant).length > 0 && subplant.plant === 'all') {
      //    if (selectedSubPlants.includes('all')) {
      //       selectedSubPlants = [];
      //       selectedSub = [];
      //    } else {
      //       selectedSub = [...allSubPlants];
      //       const allNames = ['all'];
      //       (allSubPlants || []).map((subplant) => {
      //          allNames.push(subplant.plant);
      //       });
      //       selectedSubPlants = allNames;
      //    }
      // } else {
      //    if (selectedSubPlants.includes(subplant.plant)) {
      //       if (selectedSubPlants.indexOf(subplant.plant) >= 0) {
      //          selectedSubPlants.splice(selectedSubPlants.indexOf(subplant.plant), 1);
      //       }
      //       if (selectedSubPlants.includes('all')) {
      //          selectedSubPlants.splice(selectedSubPlants.indexOf('all'), 1);
      //       }
      //       const item = selectedSub.findIndex(element => (element.plant === subplant.plant));
      //       if (item >= 0) {
      //          selectedSub.splice(item, 1);
      //       }
      //    } else {
      //       selectedSubPlants.push(subplant.plant);
      //       selectedSub.push(subplant);
      //       if (selectedSubPlants.length === allSubPlants.length) {
      //          selectedSubPlants.push('all');
      //       }
      //    }
      // }
      // this.setState({ selectedSubPlants, selectedSub, }, () => {
      //    this.props.selectedSubPlantNames(this.state.selectedSub);
      // })
      if(!subPlant && selectedSubPlants.length === allSubPlants.length) {
         selectedSubPlants = [];
      } else if(!subPlant) {
         selectedSubPlants = JSON.parse(JSON.stringify(allSubPlants));
      } else {
         const existPlant = selectedSubPlants.find(sP => sP.plant === subPlant.plant);
         if(existPlant) {
            const item = selectedSubPlants.findIndex(element => (element.plant === subPlant.plant));
            if (item >= 0) {
               selectedSubPlants.splice(item, 1);
            }
         } else {
            selectedSubPlants.push(subPlant);
         }
      }
      (allSubPlants || []).map(el => {
         const plantDetail = (selectedSubPlants || []).find(sPlant => sPlant.plant === el.plant);
         if(plantDetail) {
            existPlants.push(plantDetail);
         }
      });
      this.setState({ selectedSubPlants: existPlants }, () => {
         this.props.selectedSubPlantNames(this.state.selectedSubPlants);
      })
   }


   formSubmit = (e) => {
      e.preventDefault();
      if(!isAdaniWilmar()){
         this.saveExtendDate();
      }
   }

   // onSelectLegs = (options) => {
   //    localStorage.setItem('legs', JSON.stringify(options));
   //    this.setState({ legTypes: options });
   // }
   
   selectCHA = (option) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setCHAValue(option);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   handleContractingTypeSelection = (contractType) => {
      let { selectedContractingType,  allContractingType } = this.state;
      const { pricingBasis } = this.props;
      if (this.viewMode) {
         return;
      }
      // if(!contractType && selectedContractingType.length === allContractingType.length) {
      //    selectedContractingType = [];
      // } else if(!contractType) {
      //    selectedContractingType = JSON.parse(JSON.stringify(allContractingType));
      // } else {
      //    const existPlant = selectedContractingType && selectedContractingType.find(ct => ct.value === contractType.value);
      //    if(existPlant) {
      //       const item = selectedContractingType.findIndex(element => (element.value === contractType.value));
      //       if (item >= 0) {
      //          selectedContractingType.splice(item, 1);
      //       }
      //    } else {
      //       selectedContractingType.push(contractType);
      //    }
      // }
      selectedContractingType = [contractType];
      if(pricingBasis.length > 0 && contractType.value === 3) {
         const pricingBasislist = (pricingBasis || []).find(pricing => pricing.value == 6);
         if(pricingBasislist) {
               this.biddingDetails.setPricingBasis(pricingBasislist);
               this.props.onChange();
         }
      }
      this.setState({ selectedContractingType }, () => {
         this.props.selectedContractingType(this.state.selectedContractingType);
      })
   }

   handleContractCategoryTypeSelection = (categoryType) => {
      let { selectedContractCategoryType,  allContractCategoryType} = this.state;
      if (this.viewMode) {
         return;
      }
      // if(!categoryType && selectedContractCategoryType.length === allContractCategoryType.length) {
      //    selectedContractCategoryType = [];
      // } else if(!categoryType) {
      //    selectedContractCategoryType = JSON.parse(JSON.stringify(allContractCategoryType));
      // } else {
      //    const existPlant = selectedContractCategoryType && selectedContractCategoryType.find(ct => ct.value === categoryType.value);
      //    if(existPlant) {
      //       const item = selectedContractCategoryType.findIndex(element => (element.value === categoryType.value));
      //       if (item >= 0) {
      //          selectedContractCategoryType.splice(item, 1);
      //       }
      //    } else {
      //       selectedContractCategoryType.push(categoryType);
            
      //    }
      // }]
      selectedContractCategoryType = [categoryType];
      this.setState({selectedContractCategoryType}, ()=>{
         this.props.selectedCategoryType(this.state.selectedContractCategoryType);
      })
      const isValidName = selectedContractCategoryType.find( ({ name }) => name === 'LTC');
     if(isValidName!== undefined && isValidName.name.includes('LTC')){
      this.rfqDetails.setAcceptPartialSolution(false);
      this.rfqDetails.setContractRFQTypeLTC(isValidName.name);
      this.rfqDetails.setDisablePartialSolution(true);
     }else{
      this.rfqDetails.setAcceptPartialSolution(true);
      this.rfqDetails.setContractRFQTypeLTC("");
      this.rfqDetails.setDisablePartialSolution(false);
     }
   }

   setBoundType = (boundType) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setBoundType(boundType);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   setDedicatedType = (dedicatedType) =>{
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setDedicatedType(dedicatedType);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   setWithPincode = (type) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setWithPincode(type);
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   selectFuelType= (fuelTypes)=> {
      if(this.viewMode) {
          return;
      }
      this.rfqDetails.setFuelType(fuelTypes.value) ;
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
  }

  selectContractType = (contractTypes) => {
         if(this.viewMode) {
            return;
      }
      this.rfqDetails.setContractType(contractTypes) ;
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
  }

  calculateDays = (endTime) => {
     let validate = false;
     const user = getUser();
    const { rfqDetails } = this.state;
   if (rfqDetails.contractTenureFrom && endTime && (!user.isHOUser || user.isHOUser === "") && !user.isAdmin) {
      const momentFrom = Moment(rfqDetails.contractTenureFrom);
      const momentTo = Moment(endTime);
      const days  = momentTo.diff(momentFrom, 'days');
      if ((days > 6) && rfqDetails.serviceType !== 4 ) {
         validate = true;
      }
   }
   return validate;
}

   checkIsRangeOutSide = (contractFromDate, date) => {
      const user = getUser();
      const { rfqDetails, rfq} = this.props;
      // if (isAdaniWilmar() && !user.isHOUser && !user.isAdmin)
      //    return !Moment(date).isBetween(Moment(contractFromDate), Moment(contractFromDate).add(7, 'days'));
      if(CARGIL.includes(user.companyId) && (user.isSpotContract || (rfqDetails.movementTypeName == 'Spot' && rfq.original_rfq_id))) {
         const { contractTenureList } = this.props;
         const noDays = (contractTenureList || []).find(list => list.contract_type_id === 1) || {toRange: 1};
         return !Moment(date).isBetween(Moment(contractFromDate), Moment(contractFromDate).add(+noDays.toRange + 1, 'days'));
      } else if(isFosroc()) {
         return !Moment(date).isBetween(Moment(contractFromDate), Moment(contractFromDate).add(1, 'years'));
      } else
          return Moment(date) <= Moment(new Date().setHours(0,0,0,0));
   }

selectSpotContractReason= (reason)=> {
   if(this.viewMode) {
         return;
   }
   this.rfqDetails.setSpotContractReason(reason) ;
   this.setState({
      rfqDetails: this.rfqDetails
   })
   this.props.onChange();
}
   setTK11Table = (value) => {
      if (this.viewMode) {
         return;
      }
      this.rfqDetails.setTK11Table(value);
      this.setState({
         rfqDetails: this.rfqDetails
      });
      this.props.onChange();
   }

   selectSpotContractReason= (reason)=> {
      if(this.viewMode) {
          return;
      }
      this.rfqDetails.setSpotContractReason(reason) ;
      this.setState({
         rfqDetails: this.rfqDetails
      })
      this.props.onChange();
   }

   showUploadfilePopup = () => {  
      this.setState({
         showUploadPopup:true,
      })
   }
   onUploadContractTenureDocs = (file) => {
      const  { dispatch } = this.props;
   
        dispatch({
            type: UPLOAD_DOCUMENT,
            file,
            onSuccess: (data) => { 
               const { extend_contract_tenure_docs } = this.state;
               extend_contract_tenure_docs.push(data);
               this.setState({
                  extend_contract_tenure_docs
            });
            }
        })
   }
   deleteDoc = (index) => {
      const { extend_contract_tenure_docs } = this.state;
      extend_contract_tenure_docs.splice(index, 1);
      this.setState({
         extend_contract_tenure_docs
      });
   }

   isRFQNameDisabled = (isCopy,viewMode)=>{
      // isAdaniWilmar() ? (isCopy || this.viewMode) : false
      const C1  =  isAdaniWilmar()
      const C2 = isCopy || viewMode

      if(C1 && C2){
         return true;
      }

      const C3 = isDesmet()

      if(C3){
         return true;
      }
      
      return false;
   }
   render() {
      const { rfqDetails, rfqType, nameVal, selectedSubPlants, allSubPlants, rfq , selectedContractingType, allContractingType, allContractCategoryType, selectedContractCategoryType} = this.state;
		const { submitted, selectedSubPlant, chaList, fuelTypes, spotContractReasons, contractTenureList, ftlContractTypeList, vendorBiddingStatus } = this.props;
      const user = getUser();
      const isContractTenure = localStorage.getItem('state');
      const isEnableContractTenure = (isContractTenure === 'isEnable');
      const isHikal = HIKAL.includes(user.companyId);
      
      // const name = nameVal //+ this.props.generateRFQName;
      console.log('rfqType', rfqType, this.props.rfqType, submitted,selectedSubPlants, allSubPlants );
      var none = <Fragment></Fragment>
      const isCopy = ((this.props.match || {}).params || {}).isCopy === 'copy';
      return (

         <form onSubmit={this.formSubmit}>

            <div className="box-shadow ph-20 pv-20 br-5">
               {this.props.extendDateSubmitting && <ActionLoader />}
               <div className="fBold fs-22 border-bottom-light lh-40p mb-30" >
                  RFQ Details
                </div>
                {(isAdaniWilmar() ? (this.viewMode || isCopy) : true) && <>
               <div className="fBold fs-18 mb-10 header-medium-color" >
                  RFQ Name
                </div>

                  <Input
                     value={rfqDetails.name}
                     onChange={this.changeRFQName}
                     placeholder="Eg:Mumbai - Bangalore"
                     className="mb-10"
                     disabled={this.isRFQNameDisabled(isCopy,this.viewMode)}
                  />
               </>}
               {/* <Input value={this.props.generateRFQName} onChange={this.changeRFQName} placeholder="eg:Mumbai - Bangalore" className="mb-40" /> */}
                


               {isDesmet() && <ProjectDetails
                  project_details = {rfqDetails.project_details}
                  // handleOnChangeForProjectDetails
               />}


               {
                  user && user.hasSubplant && allSubPlants && allSubPlants.length > 0 && this.props.rfqType !== 9 &&
                  <div className="fBold fs-18 mb-20 header-medium-color">
                     <div className="fBold fs-18 mb-10 header-medium-color">
                        Sub-Plants <sup className="danger-color ml-2 pr t-4">*</sup>
                        {submitted && allSubPlants.length > 0 && selectedSubPlants.length === 0 && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Sub-Plants </div>}
                        </div>
                     {
                        ((allSubPlants || []).length > 0) && <div className="pr-10 pl-10 curP flex mb-10">
                           <Checkbox 
                              onCheck={() => this.handleSubPlantSelection()} 
                              checked={selectedSubPlants.length === allSubPlants.length} 
                           /> All</div>
                     }
                     <div className="flex wt-650 flex-wrap">
                        {
                           (allSubPlants || []).map((subplant, index) => {
                              return (
                                 <div className="pr-10 pl-10 curP flex flex-middle mb-10">
                                    <Checkbox 
                                       onCheck={() => this.handleSubPlantSelection(subplant)} 
                                       // checked={selectedSubPlants.includes(subplant.plant)} />
                                       checked={selectedSubPlants.find(subPlnt => subPlnt.plant === subplant.plant)} />
                                       {subplant.plant || ''}
                                 </div>
                              )
                           })
                        }
                     </div>
                  </div>
               }
               {user && this.props.rfqType ===1 && (user.isAccessNewFeature || []).includes('contracting_type') &&
                  <div className="fBold fs-18 mb-20 header-medium-color">
                     <div className="fBold fs-18 mb-10 header-medium-color">
                     Contracting-Type <sup className="danger-color pr t-4">*</sup>
                        {submitted && allContractingType.length > 0 && selectedContractingType.length === 0 && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Contracting type </div>}
                        </div>
                     <div className="flex wt-650 flex-wrap"> 
                        {/* {
                           ((allContractingType || []).length > 0) && <div className="pr-10 pl-10 curP flex mb-10">
                                     <Checkbox 
                                       onCheck={() => this.handleContractingTypeSelection()} 
                                       checked={ selectedContractingType && allContractingType && selectedContractingType.length === allContractingType.length} 
                                    /> All</div>
                          } */}
                          {
                           (allContractingType || []).map((type, index) => {
                              return (
                                 <div className="pr-10 pl-10 curP flex flex-middle mb-10" key={index}>
                                    <Checkbox 
                                    onCheck={() => this.handleContractingTypeSelection(type)} 
                                    checked={selectedContractingType.find(contract => contract.name === type.name)} 
                                      />
                                       {type.name || ''}
                                 </div>
                              )
                           })
                        }
                              
                     </div>
                  </div>
               }

                {(user.isShowDphDetails || ([...BACARDI, ...CARGIL, ...MITSUI].includes(user.companyId)) || this.props.rfqType === 10) ?
                  <Fragment>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                     Bound Type
                </div>
                     <div className="flex mb-35">
                        {this.props.rfqType != 10 && (<Checkbox label="In Bound" checked={rfqDetails.boundType === 1} className="mr-30" onCheck={this.setBoundType.bind(this, 1)} />)}
                        <Checkbox label="Out Bound" checked={rfqDetails.boundType === 2} className="mr-30" onCheck={this.setBoundType.bind(this, 2)} />
                        {[...BACARDI, ...CARGIL].includes(user.companyId) && <Checkbox label="External" checked={rfqDetails.boundType === 3} onCheck={this.setBoundType.bind(this, 3)} />}
                     </div>
                  </Fragment>
                  : none}

                 {(user.isShowDphDetails) ?
                  <Fragment>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                     Dedicated Type
                </div>
                     <div className="flex mb-35">
                        <Checkbox label="Dedicated" checked={rfqDetails.dedicatedType === 1} className="mr-30" onCheck={this.setDedicatedType.bind(this, 1)} />
                        <Checkbox label="Non-Dedicated" checked={rfqDetails.dedicatedType === 2} onCheck={this.setDedicatedType.bind(this, 2)} />
                     </div>
                  </Fragment>
                  : none}

               { ['98', '1782'].includes(user.companyId) && this.props.rfqType === 1 && 
                  <Fragment>
                  <div className="fBold fs-18 mb-10 header-medium-color">
                     Multi pickup and Drop with Pincode
                  </div>
                  <div className="flex mb-35">
                     <Checkbox label="Yes" checked={rfqDetails.withPincode === 1} className="mr-30" onCheck={isCopy ? null : this.setWithPincode.bind(this, 1)} />
                     <Checkbox label="No" checked={rfqDetails.withPincode === 2} onCheck={isCopy ? null : this.setWithPincode.bind(this, 2)} />
                  </div>
               </Fragment> || ''
               }

              {user  && this.props.rfqType ===1 && (user.isAccessNewFeature || []).includes('contracting_type') &&
                  <div className="fBold fs-18 mb-20 header-medium-color">
                     <div className="fBold fs-18 mb-10 header-medium-color">
                     Category-Type <sup className="danger-color pr t-4">*</sup>
                        {submitted && allContractCategoryType.length > 0 && selectedContractCategoryType.length === 0 && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Category type </div>}
                        </div>
                     <div className="flex wt-650 flex-wrap"> 
                     {/* {
                        ((allContractCategoryType || []).length > 0) && <div className="pr-10 pl-10 curP flex mb-10">
                           <Checkbox 
                              onCheck={() => this.handleContractCategoryTypeSelection()} 
                              checked={ selectedContractCategoryType && allContractCategoryType && selectedContractCategoryType.length === allContractCategoryType.length} 
                           /> All</div>
                      } */}
                          {
                           (allContractCategoryType || []).map((type, index) => {
                              return (
                                 <div className="pr-10 pl-10 curP flex flex-middle mb-10" key={index}>
                                    <Checkbox 
                                    onCheck={() => this.handleContractCategoryTypeSelection(type)} 
                                    checked={selectedContractCategoryType.find(contract => contract.name === type.name)} 
                                      />
                                       {type.name || ''}
                                 </div>
                              )
                           })
                        }
                              
                     </div>
                  </div>
               }
               {![6, 3, 9, 10].includes(this.props.rfqType)  ?
                  <Fragment>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                        Service Type
                </div>
                     {(this.props.rfqType === 5 && isHikal) && <div className={ClassNames("flex mb-5")}>
                        {
                           (SERVICE_TYPE_CATEGORIES || []).map((type, index) => {
                              return (
                                 <div className="pr-10 pl-10 curP flex flex-middle mb-10" key={index}>
                                    <Checkbox 
                                    onCheck={() => this.setServiceCategoryType(type)} 
                                    checked={rfqDetails.serviceCategoryType === type.value} 
                                       />
                                       {type.name || ''}
                                 </div>
                              )
                           })
                        }
                     </div>}
                    {this.props.rfqType !== 10 && <div className={ClassNames("flex mb-40 flex-wrap")}>
                        {
                           getUser().companyId === ACC ?
                           <Fragment key={0}>
                                    {this.shouldRenderServiceType(SERVICE_FTL.value) && <div
                                       className={ClassNames("border-white tCenter wt-100 ml-10 mr-10 pt-10 pb-10 pr", {
                                          'box-shadow select-icon border-theme br-5': rfqDetails.serviceType === SERVICE_FTL.value 
													}, {
														'box-shadow select-icon border-theme br-5': this.props.rfq.type === 2
													})}
                                       key={SERVICE_FTL.value}
                                       name={SERVICE_FTL.value}
                                       index={0}
                                       onClick={(e) => this.toggleServiceType(e, SERVICE_FTL.name)}
                                    >
                                       {SERVICE_FTL.value === 1 && <FTLIcon />}
                                       <div className={ClassNames("mt-10 fs-16 fBold tCenter", {
                                          'theme-color ': rfqDetails.serviceType === SERVICE_FTL.value,
                                          'label-color ': !(rfqDetails.serviceType === SERVICE_FTL.value)
                                       })}>
                                       <div>{SERVICE_FTL.name}</div> </div> </div>} </Fragment>
                           :
                           ((this.props.rfqType === 5 && isHikal) ? (rfqDetails.serviceCategoryType === 1) : this.props.rfqType !== 9) &&
                           <>
                            {SERVICE_TYPES.map((serviceType, index) => {
                              if(isDesmet() && serviceType.value > 1) {
                                 return;
                              }
                              return (
                                 <Fragment key={index}>
                                    {this.shouldRenderServiceType(serviceType.value) && <div
                                       className={ClassNames("border-white tCenter wt-100 ml-10 mr-10 pt-10 pb-10 pr", {
                                          'box-shadow select-icon border-theme br-5': rfqDetails.serviceType === serviceType.value 
													}, {
														'box-shadow select-icon border-theme br-5': this.props.rfq.type === 2
													})}
                                       key={serviceType.value}
                                       name={serviceType.value}
                                       index={index}
                                       onClick={(e) => this.toggleServiceType(e, serviceType.name)}
                                    >
                                       {serviceType.value === 1 && <FTLIcon />}
                                       {serviceType.value === 2 && <LCLIcon />}
                                       {serviceType.value === 3 && <CourierIcon />}
                                       {serviceType.value === 4 && <ContainerIcon />}
                                       {serviceType.value === 5 && <ContainerIcon />}
                                       {/* {serviceType.value ===5 && <BulkIcon />} */}
                                       <div className={ClassNames("mt-10 fs-16 fBold tCenter", {
                                          'theme-color ': rfqDetails.serviceType === serviceType.value,
                                          'label-color ': !(rfqDetails.serviceType === serviceType.value)
                                       })}>
                                       <div>{serviceType.name}</div>
                                          {/*{rfqDetails.serviceType === 3 && serviceType.value === 3 && rfqDetails.documentType === 1 && <div className="fs-12 mt-5">{'Document'}</div>}
                                          {rfqDetails.serviceType === 3 && serviceType.value === 3 && rfqDetails.documentType === 2 && <div className="fs-12 mt-5">{'Non Document'}</div>}*/}
                                       </div>
                                       {/*{serviceType.value === 3 && this.state.isDocumentTypeShown && <ClickOutside handleClickOutside={this.hideDocumentType}><div className="wt-max-content pa b-100p hCenter mb-10 box-shadow bg-white pb-15 pr-15 pl-15 pt-15 triangle-bottom">
													{this.props.rfqType === 2 ? <div className={ClassNames("mt-10 fs-16 fBold tCenter", {
														 'theme-color ': this.props.rfq.type === 2,
														})}>
                                          <div> { serviceType.name }</div></div>: <div className={ClassNames("mt-10 fs-16 fBold tCenter", {
															'theme-color ': rfqDetails.serviceType === serviceType.value,
															'label-color ': !(rfqDetails.serviceType === serviceType.value),
														})}>
														<div>{serviceType.name}</div>
                                          {rfqDetails.serviceType === 3 && serviceType.value === 3 && rfqDetails.documentType === 1 && <div className="fs-12 mt-5">{'Document'}</div>}
                                          {rfqDetails.serviceType === 3 && serviceType.value === 3 && rfqDetails.documentType === 2 && <div className="fs-12 mt-5">{'Non Document'}</div>}
                                       </div>}
                                       {serviceType.value === 3 && this.state.isDocumentTypeShown && <ClickOutside handleClickOutside={this.hideDocumentType}><div className="wt-max-content pa b-100p hCenter mb-10 box-shadow bg-white pb-15 pr-15 pl-15 pt-15 triangle-bottom">
                                          <Checkbox className="mb-10" onCheck={this.selectDocumentType.bind(this, 1)} label="Document" checked={rfqDetails.documentType === 1} />
                                          <Checkbox onCheck={this.selectDocumentType.bind(this, 2)} label="Non Document" checked={rfqDetails.documentType === 2} />
                                       </div></ClickOutside>}*/}
                                    </div>}
                                 </Fragment>
                              )
                           })}
                        </>
                        }
                     </div>}
                  </Fragment>
                  : none}

               {CENTURY_PLY.includes(user.companyId) && <>
                  <div className="fBold fs-18 mb-10 header-medium-color">
                     TK11 Contract Type<sup className="danger-color ml-2 pr t-4">*</sup>
                  </div>
                  <div className="flex mb-40">
                     <Checkbox label={"Vehicle Capacity"} checked={rfqDetails.tk11Table === 1} className="mr-30" onCheck={isCopy ? null : this.setTK11Table.bind(this, 1)} />
                     <Checkbox label="Vehicle Bidding" checked={rfqDetails.tk11Table === 2} onCheck={isCopy ? null : this.setTK11Table.bind(this, 2)} />
                  </div>
               </>}

               {this.props.rfqType === 5 && <Fragment>
                  <div className="fBold fs-18 mb-10 header-medium-color">
                     CHA
                  </div>
                  <Dropdown 
                     items={chaList || []} 
                     label="Select CHA" 
                     displayKey="cha_name" 
                     selectedItem={(chaList || []).find(el =>{return rfqDetails.cha_id === el.cha_id})}
                     onSelect = {this.selectCHA}
                     className="mb-30 wt-250"
                  />
               </Fragment>}

					{rfqDetails.serviceType === 3 && <Fragment>
						<div className="fBold fs-18 mb-10 header-medium-color mt-10">
							Document Type
						</div>
						<div className="flex mb-40">
							<Checkbox className="mr-30" onCheck={this.selectDocumentType.bind(this, 1)} label="Document" checked={rfqDetails.documentType === 1} />
							<Checkbox onCheck={this.selectDocumentType.bind(this, 2)} label="Non Document" checked={rfqDetails.documentType === 2} />
						</div>
               </Fragment>}
               
               {rfqDetails.serviceType === 3 && <Fragment>
						<span className="fBold fs-18 header-medium-color">
                  TAT Weightage (%)
						</span>
                  <span className="fBold fs-18 header-medium-color ml-100">
                  Price Weightage (%)
						</span>
						<div className="flex mb-40 mt-10" >
                    <Input type="number" value={rfqDetails.courierTatWeight} onChange={this.onChange}/>
							 <span className="ml-70 mt-10 border-bottom-light"> {rfqDetails.courierPriceWeight}</span> 
						</div>
					</Fragment>}
   
					{/* {rfqDetails.serviceType === 3 && <Fragment>
						<div className="fBold fs-18 mb-10 header-medium-color mt-10">
							Price Weight
						</div>
						<div className="flex mb-40">
							<Input type="number" value={rfqDetails.courierPriceWeight} onChange={this.onChange}/>
						</div>
					</Fragment>} */}

					{/* {rfqDetails.serviceType === 3 && <Fragment>
						<div className="fBold fs-18 mb-10 header-medium-color mt-10">
							TAT Weight
						</div>
						<div className="flex mb-40">
							<Input type="number" value={rfqDetails.courierTatWeight} readOnly/>
						</div>
					</Fragment>} */}
            {(this.props.rfqType === 2 || this.props.rfqType === 5 || this.props.rfqType === 6) ?
                  <Fragment>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                        Movement Type<sup className="danger-color ml-2 pr t-4">*</sup>
                        {submitted && !rfqDetails.multiLevelMovementType && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Movement Type</div>}
                     </div>
                     <div className="flex mb-40">
                        <Checkbox label={"Door To Door"} checked={rfqDetails.multiLevelMovementType === 1} className="mr-30" onCheck={isCopy ? null : this.setMultiLevelMovementType.bind(this, 1)} />
                        <Checkbox label="Leg Wise" checked={rfqDetails.multiLevelMovementType === 2} onCheck={isCopy ? null : this.setMultiLevelMovementType.bind(this, 2)} />
                     </div>
                  </Fragment>
            : none}

				{(![3, 9].includes(this.props.rfqType) && rfqDetails.serviceType !== 3 && (this.props.rfqType === 6 ? rfqDetails.multiLevelMovementType === 1 : true)) ?
                  <Fragment>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                        Service Mode
                     </div>
                     {[5, 10].includes(this.props.rfqType) && <div className={ClassNames("flex mb-5")}>
                     {
                        ((this.props.rfqType === 5 ? SERVICE_TYPE_CATEGORIES : CONTAINER_SERVICE_MODE_CATEGORIES) || []).map((type, index) => {
                           return (
                              <div className="pr-10 pl-10 curP flex flex-middle mb-10" key={index}>
                                 <Checkbox 
                                 onCheck={() => this.setServiceCategoryType(type)} 
                                 checked={rfqDetails.serviceCategoryType === type.value} 
                                    />
                                    {type.name || ''}
                              </div>
                           )
                        })
                     }
                     </div>}
                     {![10].includes(this.props.rfqType) &&<div className="flex mb-40">
                        {
                           SERVICE_MODES.map((serviceMode, index) => {
                              return (
                                 <Fragment key={index}>
                                    {this.shouldRenderServiceMode(serviceMode.value) && <div
                                       className={ClassNames("border-white tCenter wt-100 ml-10 mr-10 pt-10 pb-10", {
                                          'box-shadow select-icon border-theme br-5': rfqDetails.serviceModes.indexOf(serviceMode.value) > -1
                                       })}
                                       key={serviceMode.value}
                                       name={serviceMode.value}
                                       index={index}
                                       onClick={this.toggleServiceMode}
                                    >
                                       {serviceMode.value === 1 && <RoadIcon />}
                                       {serviceMode.value === 2 && <BusIcon />}
                                       {serviceMode.value === 3 && <RailIcon />}
                                       {(serviceMode.value === 4 || serviceMode.value === 11) && <AirIcon />}
                                       {serviceMode.value === 5 && <RoadIcon />}
                                       {serviceMode.value === 6 && <RoadIcon />}
                                       {serviceMode.value === 7 && <RailIcon />}
                                       {serviceMode.value === 8 && <RoadIcon />}
                                       {serviceMode.value === 9 && <RoadIcon />}
                                       {serviceMode.value === 10 && <RoadIcon />}
                                       <div className={ClassNames("mt-10 fs-16 fBold tCenter", {
                                          'theme-color ': rfqDetails.serviceModes.indexOf(serviceMode.value) > -1,
                                          'label-color ': !(rfqDetails.serviceModes.indexOf(serviceMode.value) > -1)
                                       })}>{this.props.rfqType === 5 ?  serviceMode.name2 : serviceMode.name}</div>
                                    </div>}
                                 </Fragment>
                              )
                           })
                        }
                     </div>}
                  </Fragment>
                  : none}


                  {(this.props.rfqType === 1 && CARGIL.includes(user.companyId)) ?
                     <>
                     <Fragment >
                        <div className="fBold fs-18 mb-10 header-medium-color mt-10">
                           Contract Type<sup className="danger-color pr t-4">*</sup>
                           {submitted && !rfqDetails.ftlContractType && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Contract Type</div>}
                        </div>
                        {/* <div className="flex mb-40">
                           <Checkbox label={"Normal "} checked={rfqDetails.ftlContractType === 1} className="mr-30" onCheck={isCopy ? null : this.setftlContractType.bind(this, 1)} />
                           <Checkbox label={"Km Slab Wise"} checked={rfqDetails.ftlContractType === 2} onCheck={isCopy ? null : this.setftlContractType.bind(this, 2)} />
                        </div> */}
                        <Dropdown 
                           items={CARGIL_FTL_CONTRACT_TYPE_LIST}
                           label="Choose Contract Type" 
                           displayKey="name" 
                           selectedItem={CARGIL_FTL_CONTRACT_TYPE_LIST.find((cType)=> {
                                 return cType.value === rfqDetails.ftlContractType
                           })}
                           onSelect = {this.setftlContractType}
                           className="mb-30 wt-250"
                        />
                     </Fragment>
                     <>
                        <div className="fBold fs-18 mb-10 header-medium-color mt-10">
                           Bidding Status Visibility
                        </div>
                           <Dropdown 
                              items={vendorBiddingStatus}
                              label="Choose" 
                              displayKey="name" 
                              selectedItem={vendorBiddingStatus.find((cType)=> {
                                    return cType.id === rfqDetails.vendorBiddingScreenId
                              })}
                              onSelect = {this.setVendorBiddingStatus}
                              className="mb-30 wt-250"
                           />
                     </>
                     </>
                  : none}  


               {this.props.rfqType === 3 ?
                  <Fragment >
                     <div className="fBold fs-18 mb-10 header-medium-color mt-10">
                        Contract Type<sup className="danger-color ml-2 pr t-4">*</sup>
                        {submitted && !rfqDetails.secondaryContractType && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Contract Type</div>}
                     </div>
                     <div className="flex mb-40">
                        <Checkbox label={isAdaniWilmar() ? "Dedicated" : "Adhoc"} checked={rfqDetails.secondaryContractType === 1} className="mr-30" onCheck={isCopy ? null : this.setSecondaryContractType.bind(this, 1)} />
                        <Checkbox label={isAdaniWilmar() ? "Slab Wise" : "Long Term"} checked={rfqDetails.secondaryContractType === 2} onCheck={isCopy ? null : this.setSecondaryContractType.bind(this, 2)} />
                     </div>
                  </Fragment>
                  : none}

                  {(this.props.rfqType === 5) ?
                     <Fragment>
                        <div className="fBold fs-18 mb-10 header-medium-color">
                           Shipping Type<sup className="danger-color ml-2 pr t-4">*</sup>
                           {submitted && !rfqDetails.shippingType && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Shipping Type</div>}
                        </div>
                        <div className="flex mb-40">
                           <Checkbox label="Import" checked={rfqDetails.shippingType === 1} className="mr-30" onCheck={this.setShippingType.bind(this, 1)} />
                           <Checkbox label="Export" checked={rfqDetails.shippingType === 2} onCheck={this.setShippingType.bind(this, 2)} />
                        </div>
                     </Fragment>
                  : none}

               {/* {(this.props.rfqType === 2 || this.props.rfqType === 5) ?
                  <Fragment>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                        Movement Type<sup className="danger-color pr t-4">*</sup>
                        {submitted && !rfqDetails.multiLevelMovementType && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Movement Type</div>}
                     </div>
                     <div className="flex mb-40">
                        <Checkbox label="Door To Door" checked={rfqDetails.multiLevelMovementType === 1} className="mr-30" onCheck={isCopy ? null : this.setMultiLevelMovementType.bind(this, 1)} />
                        <Checkbox label="Leg Wise" checked={rfqDetails.multiLevelMovementType === 2} onCheck={isCopy ? null : this.setMultiLevelMovementType.bind(this, 2)} />
                     </div>
                  </Fragment>
                  : none} */}
               {![1,6, 9, 10].includes(this.props.rfqType) ?
                  <Fragment>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                        Other Costs
                        {/* <sup className="danger-color ml-2 pr t-4">*</sup> */}
                        {/* {submitted && !rfqDetails.otherCosts && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please select Other costs</div>} */}
                     </div>
                     <div className="flex mb-40">
                        <Checkbox label="Includes" checked={rfqDetails.otherCosts} className="mr-30" onCheck={isCopy ? null : this.setOtherCosts.bind(this, 1)} />
                        <Checkbox label="Excludes" checked={!rfqDetails.otherCosts} onCheck={isCopy ? null : this.setOtherCosts.bind(this, 2)} />
                     </div>
                  </Fragment>
                  : none}
               {(isAdaniWilmar() || [...DEEPAK_PHENOLICS, ...DEEPAK_PHENOLICS_SAP].includes(getUser().companyId)) && ![9].includes(this.props.rfqType) &&
                  <>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                        Fuel Type<sup className="danger-color ml-2 pr t-4">*</sup>
                     </div>
                     <Dropdown 
                        items={fuelTypes} 
                        label="Choose Fuel Type" 
                        displayKey="name" 
                        selectedItem={fuelTypes.find((fuelTypes)=> {
                              return fuelTypes.value === rfqDetails.fuelTypes
                        })}
                        onSelect = {this.selectFuelType}
                        className="mb-30 wt-250"
                        hasError={submitted && !fuelTypes.find((fuelTypes)=> {
                              return fuelTypes.value === rfqDetails.fuelTypes
                        })}
                     /> 

                     {([1].includes(this.props.rfqType) && !([...DEEPAK_PHENOLICS, ...DEEPAK_PHENOLICS_SAP].includes(getUser().companyId))) && <>
                        <div className="fBold fs-18 mb-10 header-medium-color">
                           Contract Type 
                           <sup className="danger-color ml-2 pr t-4">*</sup>
                        </div>
                        <Dropdown 
                           items={ftlContractTypeList} 
                           label="Choose Contract Type" 
                           displayKey="name" 
                           selectedItem={ftlContractTypeList.find((contractType)=> {
                                 return contractType.id === rfqDetails.contractType
                           })}
                           onSelect = {this.selectContractType}
                           className="mb-30 wt-250"
                           hasError={submitted && !ftlContractTypeList.find((contractType)=> {
                                 return contractType.id === rfqDetails.contractType
                           })}
                        /> 
                        {rfqDetails.contractType === 5 && 
                           <>
                              <div className="fBold fs-18 mb-10 header-medium-color">
                                 Remarks for Others<sup className="danger-color pr t-4">*</sup>
                                 {submitted && !rfqDetails.otherRemarks && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Enter the Remarks</div>}
                              </div>
                              <Input value={rfqDetails.otherRemarks} onChange={this.changeOtherRemarks} className="mb-20"/>
                           </>
                        }
                     </>}
                  </>
              }
               {![9].includes(this.props.rfqType) && <>
               <div className="fBold fs-18 mb-10 header-medium-color">
                  Contract Tenure<sup className="danger-color ml-2 pr t-4">*</sup>
                  <span className="fs-12 ml-30 fs-16 fBold success-color">
                     { selectedContractCategoryType.length===0 && ((this.props.rfq.original_rfq_id && !user.isSpotContract) ? rfqDetails.movementTypeName : this.calculateMovmentType())}
                  </span>
                  {
                     ((this.props.rfq.original_rfq_id && !user.isSpotContract) ? rfqDetails.movementTypeName : this.calculateMovmentType()) && rfqDetails.serviceType !== 4 && selectedContractCategoryType.length===0 &&
                     <Fragment>
                        <a data-tip data-for='contract-tenture-tooltip'> <span className="tooltip-icon fBold">i</span> </a>
                        <ReactTooltip id='contract-tenture-tooltip' type="dark" effect="solid">
                           {contractTenureList && contractTenureList.length > 0 ?
                           <>{(contractTenureList || []).map((contract, index) => ( 
                                 <>
                                    {contract.contract_type_id !== 4 ? 
                                    <>
                                       <span>{`${contract.contract_type} : ${contract.fromRange} - ${contract.toRange} ${contract.uom}`}</span><br/>
                                    </> :
                                    <span>{`${contract.contract_type} : Above ${contract.fromRange} ${contract.uom}`}</span>}
                                 </>))}
                           </> :
                           <>
                              <span> Spot : 1 Day </span><br />
                              <span> Short : 2 - 7 Days </span><br />
                              <span> Monthly : 8 - 31 Days </span><br />
                              <span> Long : Above 31 Days </span><br />
                           </>}
                        </ReactTooltip>
                     </Fragment>
                  }
                  {
                     ((this.props.rfq.original_rfq_id && !user.isSpotContract) ? rfqDetails.movementTypeName : this.calculateMovmentType()) && rfqDetails.serviceType === 4 && selectedContractCategoryType.length===0 && 
                     <Fragment>
                        <a data-tip data-for='contract-tenture-tooltip'> <span className="tooltip-icon fBold">i</span> </a>
                        <ReactTooltip id='contract-tenture-tooltip' type="dark" effect="solid">
                           <span> Short : 0 - 7 Days </span><br />
                           <span> Long : Above 7 Days </span><br />
                        </ReactTooltip>
                     </Fragment>
                  }
               </div>
               <div className="mb-40" >
                  <DateRangePicker
                     startDate={!rfqDetails.contractTenureTo ? Moment(rfqDetails.contractTenureFrom || null) : Moment(rfqDetails.contractTenureFrom)}
                     startDateId="startDate"
                     endDate={rfqDetails.contractTenureTo ? Moment(rfqDetails.contractTenureTo) : null}
                     endDateId="endDate"
                     onDatesChange={({ startDate, endDate }) => {
                        const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0)
                        this.rfqDetails.setContractTenureFrom(startDateTime)
                        const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                        if(isAdaniWilmar() ? !this.calculateDays(endTime ? new Date(endTime).getTime() : this.state.endDate) : true) {
                           this.rfqDetails.setContractTenureTo(endTime ? new Date(endTime).getTime() : this.state.endDate)
                           this.setState({
                              rfqDetails: this.rfqDetails
                           })
                        } 
                     }}
                     focusedInput={this.state.focusedInput}
                     onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                     displayFormat={'DD MMM YYYY'}
                     noBorder={true}
                     minimumNights={0}
                     isOutsideRange={(date) => this.checkIsRangeOutSide(rfqDetails.contractTenureFrom, date)}
                  />
                  {/* {submitted && (rfqDetails.serviceType === 4) && 
                    (Moment.duration(Moment(rfqDetails.contractTenureTo).diff(Moment(rfqDetails.contractTenureFrom))).asDays() > 6) && 
                    <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Date should be between 0 to 7 days.</div>} */}
                  {submitted && !rfqDetails.contractTenureTo && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Contract Tenure End Date</div>}
                  {!isAdaniWilmar()&& (isEnableContractTenure) && <button type="submit" class="ml-5 bg-theme wt-100 mb-20 ht-40 br-20 fBold fs-16 white-color">Save</button>}
                  {isAdaniWilmar()&& (isEnableContractTenure) && <button onClick={this.showUploadfilePopup} class="ml-5 bg-theme wt-100 mb-20 ht-40 br-20 fBold fs-16 white-color">Save</button>}

                  {(this.viewMode) && !rfqDetails.contractTenureTo && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Contract Tenure End Date</div>}
                  {isAdaniWilmar() && !user.isHOUser && !user.isAdmin && <div className="orange-dark-color fs-14 fSemibold op-7 ml-5 mt-5">Contract Tenture Should Be Between 7 Days</div>}
               </div>

               {CARGIL.includes(user.companyId) && rfqDetails.movementTypeName == 'Spot' &&
                  <>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                       Spot Contract Reason<sup className="danger-color ml-2 pr t-4">*</sup>
                     </div>
                     <Dropdown 
                        items={spotContractReasons} 
                        label="Choose Reason" 
                        displayKey="name" 
                        selectedItem={spotContractReasons.find((reason)=> {
                              return reason.id === rfqDetails.spotContractReasonId
                        })}
                        onSelect = {this.selectSpotContractReason}
                        className="mb-30 wt-250"
                        hasError={submitted && !spotContractReasons.find((reason)=> {
                              return reason.id === rfqDetails.spotContractReasonId
                        })}
                     /> 
                  </>
              }
               
               <div className="fBold fs-18 mb-10 header-medium-color">
                  Insurance By
                </div>
               <div className="flex mb-40">
                  {
                  ((this.props.rfqType === 5 && isHikal) ? INSURANCE_BY.filter(el => el.value !== 4) : INSURANCE_BY).map((insuranceBy, index) => {
                        return (
                           <div
                              className={ClassNames("border-white tCenter wt-100 ml-10 mr-10 pt-10 pb-10", {
                                 'box-shadow select-icon border-theme br-5': rfqDetails.insuranceBy === insuranceBy.value
                              })}
                              key={insuranceBy.value}
                              name={insuranceBy.value}
                              index={index}
                              onClick={this.selectInsuranceBy}
                           >
                              {insuranceBy.value === 1 && <ConsignerIcon />}
                              {insuranceBy.value === 2 && <ConsigneeIcon />}
                              {insuranceBy.value === 3 && <AgreedMutuallyIcon />}
                              {insuranceBy.value === 4 && <NotAvailableIcon width="40" height="40"/>}
                              <div className={ClassNames("mt-10 fs-16 fBold tCenter", {
                                 'theme-color ': rfqDetails.insuranceBy === insuranceBy.value,
                                 'label-color ': !(rfqDetails.insuranceBy === insuranceBy.value)
                              })}>{insuranceBy.name}</div>
                           </div>
                        )
                     })
                  }
               </div>
               </>}

					{(!['737', ...CARGIL].includes(getUser().companyId) && ![3,6,9, 10].includes(this.props.rfqType) && rfqDetails.serviceType !== 3 && (this.props.rfqType === 5 ? !isHikal : true)) ?
                  <Fragment>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                        Trips type

                     </div>
                     <div className="flex">
                        <Checkbox label="Trip" checked={rfqDetails.tripsType === 1} className="mr-30" onCheck={this.setTripsType.bind(this, 1)} />
                        <Checkbox label="Lot" checked={rfqDetails.tripsType === 2} onCheck={this.setTripsType.bind(this, 2)} />
                     </div>
                  </Fragment>
                  : none}
               {[9].includes(this.props.rfqType) && 
                  <>
                     <div className="fBold fs-18 mb-10 header-medium-color">
                     Inco Terms
                     </div>
                     <div className="flex mb-35">
                        <Checkbox label="Sales For" checked={rfqDetails.incoTerms === 1} className="mr-30" onCheck={this.setIncoTerms.bind(this, 1, 'Sales For')} />
                        <Checkbox label="Ex-Works" checked={rfqDetails.incoTerms === 2} onCheck={this.setIncoTerms.bind(this, 2, 'Ex-Works')} />
                     </div>

                     <div className="fBold fs-18 mb-10 header-medium-color">
                     Contract Type
                     </div>
                     <div className="flex mb-35">
                        <Checkbox label="Depot Wise" checked={rfqDetails.disposalContractType === 1} className="mr-30" onCheck={this.setDisposalContractType.bind(this, 1)} />
                        <Checkbox label="Zone Wise" checked={rfqDetails.disposalContractType === 2} onCheck={this.setDisposalContractType.bind(this, 2)} />
                     </div>
                  </>}
            </div>
            {!!this.state.showUploadPopup &&
               <UploadFilePopup
               // onChange={this.onRemarksChange}
               value={this.state.extend_contract_tenure_remarks}
               onChange={(e) => this.setState({
                  extend_contract_tenure_remarks: e.target.value
               })}
               loi_docs={this.state.extend_contract_tenure_docs}
                onUploadLoiDocs={this.onUploadContractTenureDocs}
                deleteDoc={this.deleteDoc}
                onCancel={() => {
                     this.setState({
                        extend_contract_tenure_remarks: '',
                        extend_contract_tenure_docs: [],
                        mandatory_error_message:false,
                        showUploadPopup:false,
                     })
               }}
                downloadUploadedFile={this.downloadUploadedFile}
                onSave={() =>this.saveExtendDate()}
                mandatory_error_message={this.state.mandatory_error_message}
               />

               }

         </form>
      )                  
   }
}
const mapStateToProps = ({ contracting }) => {
   return {
      extendDateSubmitting: contracting.extendEditDate.dataSubmitting,
   }
};
export default connect(mapStateToProps)(withRouter(RFQDetails));
